import { render } from "./PlansAudit.vue?vue&type=template&id=9a70231e&scoped=true"
import script from "./PlansAudit.vue?vue&type=script&lang=js"
export * from "./PlansAudit.vue?vue&type=script&lang=js"

import "./PlansAudit.vue?vue&type=style&index=0&id=9a70231e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a70231e"]])

export default __exports__